import { render, staticRenderFns } from "./AddCustomerToProductModal.vue?vue&type=template&id=2884c037&scoped=true&"
import script from "./AddCustomerToProductModal.vue?vue&type=script&lang=ts&"
export * from "./AddCustomerToProductModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2884c037",
  null
  
)

export default component.exports